import "./widget.scss";
import {
	Avatar,
	Box,
	Card,
	CardContent,
	CardHeader,
	IconButton,
} from "@mui/material";

export const Widget = ({ heading, content, icon }) => {
	return (
		<Card sx={{ minWidth: 300 }}>
			<CardHeader
				action={<IconButton aria-label='settings'>{icon}</IconButton>}
				title={content}
				subheader={heading}
			/>
		</Card>
	);
};